import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CurrentAndNextHeats } from "../models/CurrentAndNextHeats";
import { OverviewReponse } from "../models/OverviewResponse";
import { StandSpare } from "../models/StandSpare";

const moment = getMomentTz();

export const getMillOverview = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[M2].[GetMillOverview]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const data = resp.data as OverviewReponse;

		data.tables[0].rows = data.tables[0].rows.map((row) => {
			InstalledAt: row.InstalledAt
				? moment.utc(row["InstalledAt"]).toDate()
				: null;
			return row;
		});
		data.tables[1].rows = data.tables[1].rows.map((row) => {
			Start: row.Start ? moment.utc(row["Start"]).toDate() : null;
			End: row.End ? moment.utc(row["End"]).toDate() : null;
			return row;
		});

		return {
			errorMessage: null,
			tables: data.tables,
		} as OverviewReponse;
	} else {
		throw new Error(resp.message || "Error fetching mill overviews");
	}
};

export const getMillDetailsByStandId = async (
	params: { standId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "StandId", value: params.standId },
	];

	const resp = await apiService.callV2(
		"[M2].[GetMillDetailsByStandId]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as StandSpare[];
	} else {
		throw new Error(resp.message || "Error fetching mill overviews");
	}
};

export const getCurrentHeats = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "TagsCount", value: 5 }];

	const resp = await apiService.callV2(
		"[M2].[GetCurrentAndNextHeats]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CurrentAndNextHeats[];
	} else {
		throw new Error(resp.message || "Error fetching current heats");
	}
};

export const replaceCarrierRolls = async ({
	carrierInstanceId,
	rollsetId,
}: {
	carrierInstanceId: number;
	rollsetId: number;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "CarrierInstanceId", value: carrierInstanceId },
		{ name: "RollsetId", value: rollsetId },
	];

	const resp = await apiService.callV2(
		"[M2].[ReplaceCarrierRolls]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error replacing carrier rolls");
	}
};

export const upsertComments = async ({
	standId,
	comments,
}: {
	standId: number;
	comments: string;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StandId", value: standId },
		{ name: "Comments", value: comments },
	];

	const resp = await apiService.callV2("[M2].[UpsertComments]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error upserting comments");
	}
};
